import { useRouter } from 'next/router';
import Footer from '@common/footer';
import Content from '@components/common/content';
import { CompanyChannelCustomHead, CompanyNotFoundCustomHead } from '@components/common/customHead';
import Header from '@components/common/header';
import Layout from '@components/common/layout';
import CompanyDetail from '@components/company/sn';
import { useCompaniesInformation } from '@repository/companies/useCompanies';

const Info = () => {
  const router = useRouter();
  const { sn } = router.query;
  const { data: companyInfoData, isFetched } = useCompaniesInformation(Number(sn));

  return (
    <Layout>
      {isFetched &&
        (companyInfoData ? <CompanyChannelCustomHead metaData={companyInfoData} /> : <CompanyNotFoundCustomHead />)}
      <Header />
      <Content>
        <CompanyDetail />
      </Content>
      <Footer />
    </Layout>
  );
};

export default Info;
